import { PriceResponseV2, PricesResponseV2 } from "@ssc-booking/api-contracts"
import * as A from "fp-ts/Array"
import * as F from "fp-ts/function"
import * as O from "fp-ts/Option"
import * as ROA from "fp-ts/ReadonlyArray"
import { availablePrices } from "../../../_common/price-response"

export type SuitePriceE = PricesResponseV2["prices"][0]

export const suiteCategoryPriceByCodes = (
    suitesPrices: readonly SuitePriceE[],
    codes: string[],
): O.Option<PriceResponseV2> => {
    const availableSuitePrices = availablePrices(suitesPrices)
    return suiteCategoryAvailablePriceByCodes(codes, availableSuitePrices)
}

const suiteCategoryAvailablePriceByCodes = (codes: string[], suitesPrices: readonly PriceResponseV2[]) =>
    F.pipe(codes, A.map(findPrice(suitesPrices)), A.compact, A.head)

const findPrice =
    (suitesPrices: readonly PriceResponseV2[]) =>
    (code: string): O.Option<PriceResponseV2> =>
        F.pipe(
            suitesPrices,
            ROA.findFirst((p) => p.suiteCategory == code),
        )
